import { neutral0, shadowDp16 } from '@fever/ui';
import React from 'react';
import { css } from '@emotion/core';

export default function Panel({ children, style, ...props }) {
    return (
        <div css={[containerStyle, css(style)]} {...props}>
            {children}
        </div>
    );
}

const containerStyle = css`
    width: 360px;
    background-color: ${neutral0};
    border-radius: 12px;
    padding: 24px;
    box-shadow: ${shadowDp16};
`;
